import { render, staticRenderFns } from "./sharecard.vue.html?vue&type=template&id=5b6dcc1d&scoped=true"
import script from "./sharecard.controller?vue&type=script&lang=js&external"
export * from "./sharecard.controller?vue&type=script&lang=js&external"
import style0 from "./sharecard.vue.html?vue&type=style&index=0&id=5b6dcc1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6dcc1d",
  null
  
)

export default component.exports